import { forwardRef, createElement } from 'react';
import { Button as OriginalButton, ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import 'antd/dist/antd.variable.min.css';
import '../../variables.scss';
const Button = (props, ref) => {
    ConfigProvider.config({
        theme: {
            primaryColor: '#f16622',
        },
    });
    const innerProps = {};
    if (!props.href?.trim() || props.__designmode === 'design') {
        // 解决低代码编辑器中按钮设置href属性造成按钮点击重定向问题
        innerProps.href = undefined;
    }
    const { __designmode, ...restProps } = props;
    return (createElement(ConfigProvider, { locale: localStorage.getItem('umi_locale') !== 'en-US' ? zhCN : enUS },
        createElement(OriginalButton, { ...restProps, ...innerProps, ref: ref })));
};
export default forwardRef(Button);
